import { Laugh, Users, Zap, Bomb } from "lucide-react";
import Mascot from "./Mascot";
import Reveal, { SectionHead } from "./Reveal";

const CARDS = [
    { label: "MEMES", icon: Laugh, pos: "lg:left-[4%] lg:top-[10%]", color: "border-cyan-400/40 text-cyan-300", delay: "0s" },
    { label: "COMMUNITY", icon: Users, pos: "lg:right-[4%] lg:top-[16%]", color: "border-purple-400/40 text-purple-300", delay: "0.8s" },
    { label: "SOLANA", icon: Zap, pos: "lg:left-[8%] lg:bottom-[14%]", color: "border-green-400/40 text-green-300", delay: "1.6s" },
    { label: "CHAOS", icon: Bomb, pos: "lg:right-[8%] lg:bottom-[8%]", color: "border-orange-400/40 text-orange-300", delay: "2.4s" },
];

export default function WhyBald() {
    return (
        <section data-testid="why-bald-section" className="relative overflow-hidden py-24 lg:py-32">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_50%_50%,rgba(0,240,255,0.07),transparent)]" />
            <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">
                <SectionHead kicker="WHY BALD?" title="WHY $BALD?" />
                <p className="mx-auto mt-5 max-w-xl text-center text-base md:text-lg text-slate-400">
                    Sometimes you don't need a complicated reason.
                    <br />
                    Sometimes you just need a bald pigeon.
                </p>

                <div className="relative mt-12 flex justify-center lg:mt-6">
                    {CARDS.map((c) => (
                        <div
                            key={c.label}
                            className={`animate-floaty absolute z-10 ${c.pos} hidden lg:block`}
                            style={{ animationDelay: c.delay }}
                        >
                            <div
                                data-testid={`why-card-${c.label.toLowerCase()}`}
                                className={`glass flex items-center gap-3 rounded-2xl px-6 py-4 ${c.color}`}
                            >
                                <c.icon className="h-6 w-6" />
                                <span className="headline text-xl">{c.label}</span>
                            </div>
                        </div>
                    ))}
                    <Reveal>
                        <div className="relative">
                            <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[80%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[conic-gradient(from_90deg,rgba(0,240,255,0.2),rgba(168,85,247,0.25),rgba(0,240,255,0.05),rgba(0,240,255,0.2))] blur-2xl" />
                            <Mascot name="why" className="mx-auto w-full max-w-sm lg:max-w-md" />
                        </div>
                    </Reveal>
                </div>

                <div className="mt-10 grid grid-cols-2 gap-4 lg:hidden">
                    {CARDS.map((c) => (
                        <div
                            key={`m-${c.label}`}
                            data-testid={`why-card-mobile-${c.label.toLowerCase()}`}
                            className={`glass flex items-center justify-center gap-3 rounded-2xl px-4 py-5 ${c.color}`}
                        >
                            <c.icon className="h-5 w-5" />
                            <span className="headline text-lg">{c.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
